import classNames from 'classnames';
import { FC, useMemo } from 'react';
import Head from 'next/head';

import * as style from '@/styles/generic.module.scss';
import { BuilderModel } from '@/utils/Builder';

import { B2BFooter } from '../afterpay-goes-green/b2b-footer/b2b-footer';
import B2BNewsletter from '../afterpay-goes-green/b2b-newsletter/b2b-newsletter';
import { B2BTopNavigation } from '../afterpay-goes-green/b2b-top-navigation/b2b-top-navigation';
import { ICONS } from '../business-button/business-button.constants';
import BusinessFooter from '../business-footer/business-footer';
import BusinessHubFootnotes from '../business-hub-footnotes/business-hub-footnotes';
import Icon from '../icons';

interface Props {
    page: any;
    model: string;
}

const B2BLayout: FC<Props> = (props) => {
    const { page, model, children } = props;

    const { footerItems, theme, footnotes, hideFooter, hideNav, showContactUsForm, showSayHello, showReadyToGrow } = page?.data || {};

    const localeName = useMemo(() => {
        return 'United States';
    }, []);

    const copyright = useMemo(() => {
        return '© 2025 Afterpay';
    }, []);

    const onboardingLink = useMemo(() => {
        return 'https://hub.us.afterpay.com/signup';
    }, []);

    const LocaleIcon = localeName ? (
        <div className={(style as any)['locale']}>
            <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.2222 1.02319V2.78424C13.7256 3.35398 15.7715 5.14095 16.7038 7.48034C15.055 6.63436 12.7156 6.15092 10.3589 6.04733V1.71383C10.3589 1.71383 10.3589 1.71382 10.3589 1.70519V0.89379C10.0741 0.867893 9.78918 0.850586 9.49568 0.850586C4.25579 0.850586 0 5.10638 0 10.3463C0 14.9905 3.35802 18.8579 7.76919 19.678V17.9169C5.26579 17.3472 3.21989 15.5602 2.28759 13.2208C3.93639 14.0668 6.28442 14.5589 8.64108 14.6538V18.0723V19.8074C8.92595 19.8333 9.21082 19.8506 9.50432 19.8506C14.7442 19.8506 19 15.5948 19 10.3549C19 5.71066 15.642 1.84327 11.2308 1.02319H11.2222ZM17.2649 10.3549C17.2649 11.3476 14.6061 12.7547 10.3589 12.9274V7.78246C14.5974 7.95511 17.2649 9.36218 17.2649 10.3549ZM8.63244 2.63756V6.05597C6.27578 6.15093 3.92777 6.64301 2.27898 7.48898C3.3235 4.87336 5.74057 2.95696 8.63244 2.63756ZM1.72649 10.3549C1.72649 9.36218 4.39391 7.95511 8.63244 7.78246V12.9274C4.38528 12.7547 1.72649 11.3476 1.72649 10.3549ZM10.3589 18.0723V14.6538C12.7156 14.5589 15.055 14.0668 16.7038 13.2208C15.6592 15.8278 13.2508 17.7442 10.3589 18.0723Z"
                    fill="black"
                />
            </svg>
            <span>
                <strong>{localeName}</strong>
            </span>
        </div>
    ) : null;

    return (
        <div className={classNames((style as any)['b2b-layout'], 'b2b-layout')}>
            <Head>
                <link rel="icon" href="/us-favicon.svg" />
            </Head>

            {hideNav ? null : <B2BTopNavigation page={page} model={model} signupLink={onboardingLink} />}

            <div className={classNames((style as any)['content'], (style as any)['--no-top-padding'])}>{children}</div>

            <div className={(style as any)['footer']}>
                {model === BuilderModel.BUSINESS_HUB ? (
                    <>
                        {hideFooter ? null : (
                            <B2BFooter
                                theme={theme}
                                showContactUsForm={showContactUsForm}
                                showSayHello={showSayHello}
                                showReadyToGrow={showReadyToGrow}
                                footerLink={onboardingLink}
                                page={page}
                            />
                        )}
                        <BusinessHubFootnotes content={footnotes} />
                    </>
                ) : (
                    <B2BNewsletter />
                )}

                {LocaleIcon ? <div className={classNames((style as any)['disclaimers-box'], (style as any)['mobile'])}>{LocaleIcon}</div> : null}

                <div className={localeName ? (style as any)['footer-nav'] : ''}>
                    <BusinessFooter theme="white" hideLogo footerData={footerItems} isB2bAnz={false} />
                </div>

                {localeName ? (
                    <div className={(style as any)['disclaimers-box']}>
                        <div className={(style as any)['disclaimers']}>
                            <div className={(style as any)['desktop']}>{LocaleIcon}</div>
                            {copyright ? <div className={(style as any)['copyright']}>{copyright}</div> : null}
                        </div>

                        <div className={(style as any)['logo']}>
                            <Icon type={ICONS.AfterpayLogo} />
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default B2BLayout;
